import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { ParametrosGeneralesUACComponent } from './parametros-generales-UAC.component';
import { ConfiguracionVentanillaComponent } from './configuracion-ventanilla/configuracion-ventanilla.component';
import { AuthGuard } from 'src/app/shared/guards/authGuard/auth.guard';
import { ConfigurarMotivoConsultaComponent } from './configurar-motivo-consulta/configurar-motivo-consulta.component';

const routes: Routes = [
    { path: '', component: ParametrosGeneralesUACComponent },
    { path: 'ventanilla', component: ConfiguracionVentanillaComponent, canActivate: [AuthGuard] },
    { path: 'configurar-motivo-consulta', component: ConfigurarMotivoConsultaComponent, canActivate: [AuthGuard] }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class ParametrosGeneralesUACRouting { }
